import { black } from "@/theme/colors";
import { Box, Stack, Typography } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { ReactNode, useState } from "react";

type CollapsibleSectionHeaderProps = {
  title: string;
  expanded: boolean;
  onToggle: () => void;
  children?: ReactNode;
};

export const useCollapsible = (defaultExpanded = true) => {
  const [expanded, setExpanded] = useState(defaultExpanded);
  const toggle = () => setExpanded((prev) => !prev);
  return { expanded, toggle };
};

export const CollapsibleSectionHeader = ({ title, expanded, onToggle, children }: CollapsibleSectionHeaderProps) => (
  <Stack direction="row" alignItems="center" spacing={2} onClick={onToggle} sx={{ cursor: "pointer", userSelect: "none" }}>
    <Box flex={1}>
      <Typography variant="sub16Bold" color={black[30]}>
        {title}
      </Typography>
    </Box>
    {children}
    <KeyboardArrowUpIcon
      sx={{
        color: black[80],
        transition: "transform 0.2s",
        transform: expanded ? "rotate(0deg)" : "rotate(180deg)",
      }}
    />
  </Stack>
);
